export const CREATE_CHECKOUT_SESSION_URL = `${process.env.REACT_APP_DEMO_API_URL_BASE}/create-checkout-session`;
